import { createSnapshotValue as createMutable } from '../../lib/snapshot-value.ts'

/** Spec ACC-01: the currencies an order or invoice may be in. UAH is the base. */
export interface Currency {
  code: string
  name: string
  /** UAH per unit, from the saved NBU rate. Null for UAH itself. */
  rate: string | null
  active: boolean
  isDefault: boolean
}

export const CURRENCIES: Currency[] = createMutable([] as Currency[])

export const activeCurrencies = () => CURRENCIES.filter((currency) => currency.active)

/**
 * How VAT is applied. The accountant decides the rate and whether a typed price already
 * includes it; documents copy the mode, so a later change never rewrites an issued invoice.
 */
export interface VatMode {
  key: string
  name: string
  rate: string
  priceIncludesVat: boolean
  active: boolean
  isDefault: boolean
}

export const VAT_MODES: VatMode[] = createMutable([] as VatMode[])

export const activeVatModes = () =>
  [...VAT_MODES.filter((mode) => mode.active)].sort(
    (left, right) => Number(right.isDefault) - Number(left.isDefault),
  )
